export default {
  code: {
    lockError: 500001,
    overOnlineLimit: 502002, // 在线人数超过上限
    projectNotExist: 4004, // 项目不存在这个账号下
  },
  command: {
    lockDmaker: 'dmaker/edit/lock',
    lockGmaker: 'gmaker/edit/lock',
    lockPs: 'ps/edit/lock',
    lockAigc: 'aigc/edit/lock',
    lockAiBanner: 'ai_banner/edit/lock',
    onlineCheck: 'online/check',
    ping: 'ping',
    locVeditor: 'veditor/edit/lock',
    // 任务中心的任务更新状态
    jobUpdate: 'async/job_update',
  },
}
